import { animated, useSpring } from '@react-spring/web';
import { Check, X } from 'lucide-react';

interface Props {
  isVisible: boolean;
  title: string;
  message: string;
  onClose: () => void;
}

const SuccessAlertV2 = ({ isVisible, title, message, onClose }: Props) => {
  const { opacity, y } = useSpring({
    opacity: isVisible ? 1 : 0,
    y: isVisible ? 0 : -8,
    config: { tension: 260, friction: 22 },
  });

  if (!isVisible) return null;

  return (
    <animated.div
      style={{
        opacity,
        transform: y.to((v) => `translateY(${v}px)`),
      }}
      className="mb-6"
    >
      <div
        className="
          relative

          flex
          items-start
          gap-4

          rounded-xl

          border
          border-meta-3/30

          bg-meta-3/10

          p-5

          shadow-card

          dark:border-meta-3/20
          dark:bg-meta-3/10
        "
      >
        {/* Línea lateral */}
        <div className="absolute left-0 top-0 h-full w-1 rounded-l-xl bg-meta-3" />

        {/* Icono */}
        <div
          className="
            flex
            h-10
            w-10
            flex-none
            items-center
            justify-center

            rounded-lg

            bg-meta-3

            text-white
          "
        >
          <Check className="h-5 w-5" />
        </div>

        {/* Contenido */}
        <div className="min-w-0 flex-1">
          <h4
            className="
              text-base
              font-semibold

              text-black
              dark:text-white
            "
          >
            {title}
          </h4>

          <p
            className="
              mt-1

              text-sm

              text-body
              dark:text-bodydark
            "
          >
            {message}
          </p>
        </div>

        {/* Cerrar */}
        <button
          onClick={onClose}
          className="
            rounded-lg

            p-1.5

            text-bodydark2

            transition-colors

            hover:bg-meta-3/10
            hover:text-meta-3
          "
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </animated.div>
  );
};

export default SuccessAlertV2;
